import { render } from "./record-msg-box.vue?vue&type=template&id=e36b8bda&scoped=true&ts=true"
import script from "./record-msg-box.vue?vue&type=script&lang=ts"
export * from "./record-msg-box.vue?vue&type=script&lang=ts"

import "./record-msg-box.vue?vue&type=style&index=0&id=e36b8bda&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36b8bda"]])

export default __exports__